import { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'motion/react';

const INTERVAL = 5000;

export function HeroCarousel({ slides }) {
  const reduce = useReducedMotion();
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (reduce || paused) return undefined;
    const id = setTimeout(() => setIndex((i) => (i + 1) % slides.length), INTERVAL);
    return () => clearTimeout(id);
  }, [index, paused, reduce, slides.length]);

  const slide = slides[index];

  return (
    <div onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
      <div className="min-h-[132px] md:min-h-[116px]">
        <AnimatePresence mode="wait">
          <motion.div
            key={index}
            initial={reduce ? false : { opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            exit={reduce ? undefined : { opacity: 0, y: -14 }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-zinc-50 leading-[1.05]">
              {slide.headline}
            </h1>
            <p className="mt-6 max-w-xl text-lg text-zinc-400 md:text-xl">{slide.subtext}</p>
          </motion.div>
        </AnimatePresence>
      </div>

      <div className="mt-6 flex max-w-xs gap-1.5" role="tablist" aria-label="Marketing messages">
        {slides.map((s, i) => (
          <button
            key={s.headline}
            type="button"
            role="tab"
            aria-selected={i === index}
            aria-label={`Show message ${i + 1} of ${slides.length}`}
            onClick={() => setIndex(i)}
            className="h-1 flex-1 overflow-hidden rounded-full bg-white/10"
          >
            {i === index && (
              <span
                key={index}
                className="block h-full origin-left rounded-full bg-indigo-500"
                style={
                  reduce
                    ? { width: '100%' }
                    : {
                        transform: 'scaleX(0)',
                        animationName: 'hero-progress-fill',
                        animationDuration: `${INTERVAL}ms`,
                        animationTimingFunction: 'linear',
                        animationFillMode: 'forwards',
                        animationPlayState: paused ? 'paused' : 'running',
                      }
                }
              />
            )}
            {i < index && <span className="block h-full rounded-full bg-indigo-500" />}
          </button>
        ))}
      </div>
    </div>
  );
}
